import { ACTIONS_TYPES } from "../utils/constants";


export function loginRequest(loginData) {
  return {
    type: ACTIONS_TYPES.LOGIN_REQUEST,
    payload: loginData
  }
}

export function loginSuccess(response) {
  return {
    type: ACTIONS_TYPES.LOGIN_SUCCESS,
    payload: response,
  }
}

export function loginFailed(response) {
  return {
    type: ACTIONS_TYPES.LOGIN_FAILED,
    payload: response,
  }
}

export function loginReset() {
  return {
    type: ACTIONS_TYPES.LOGIN_RESET,
  }
}

export function logout() {
  return {
    type: ACTIONS_TYPES.LOGOUT_REQUEST,
  }
}